export default "__VITE_ASSET__CeBZxVnQ__"